export enum ChargeStatus
{
    Requested = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
    Expired = 5,
}